import { queryClient } from '~/lib/query-client'

const urlParams = new URLSearchParams(window.location.search)

export const language = urlParams.get('language') || 'en' // en, zh_tw, ...

export type Platform = 'ios' | 'googleplay_android' | 'china_android'

export const platform = urlParams.get('platform') as Platform

export const appVersion = urlParams.get('app_version') ?? '0.0.0'

export const shouldMockAPI = urlParams.has('mock')

const tsParam = urlParams.get('ts')
export const timestamp = tsParam ? new Date(Number(tsParam) * 1000) : new Date()

queryClient.setQueryData(['timestamp'], timestamp)
